import React from "react";
import { DPDirectDepositUpdateFile } from "Shared/types/DirectDeposit";
import { TableRow, TableCell, Link } from "@material-ui/core";
import pretty from "Shared/pretty";
import Formatting from "Modules/DataExchange/Formatting";
import { DPPermissionGate } from "Components/DP";

const DirectDepositTableRow = ({ ...directDepositFile }: DPDirectDepositUpdateFile) => {
  const { creator, attachment, createdAt } = directDepositFile;
  const fullName = Formatting.dataExchangeFullName(
    creator.firstName || "",
    creator.lastName || ""
  );
  return (
    <TableRow>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>{fullName}</TableCell>
      <TableCell>
        {pretty.file(attachment?.path || "").fileName}
      </TableCell>
      <DPPermissionGate permissionKeys={["canDownloadDirectDepositUpdates"]}>
        <TableCell>
          <Link href={attachment?.url || "#"} download>
            Download
          </Link>
        </TableCell>
      </DPPermissionGate>
    </TableRow>
  );
};

export default DirectDepositTableRow;
